import React, { FC, useState, useEffect, useCallback } from "react";
import SmartTable from "../../components/SmartTable";
import { Button, Space, Input } from "antd";
import {
  ClientsIcon,
  SearchIcon,
  UserIcon,
  VideoIcon,
} from "../../components/Icon";
import { Dispatch } from "redux";
import { useDispatch, useSelector } from 'react-redux';
import { resetHeader, setHeader } from '../../store/main';
import headerConfigs from '../../services/headerConfig';
import { getUsers } from "../../store/users";
import moment from "moment";
import UserDrawer from "../../components/UserDrawer";
import { getUsersDetails } from "../../store/users/UsersServices";
import getCol from '../../components/TableList/Columns';

const User: FC = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const [data, setData] = useState([])
  const [dataSource, setDataSource] = useState(data);
  const [columns, setColumns] = useState(getCol());
  const [activeType, setActiveType] = useState<string>("all");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [visible, setVisible] = useState<boolean>(false);
  const [tableData, setTableData] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<any>('');
  const page = useSelector((state: any) => state.user.page);
  const lastPage = useSelector((state: any) => state.user.lastPage);
  const usersData = useSelector((state: any) => state.user.usersData);
  const usersDetailsData = useSelector((state: any) => state.user.usersDetails);
  const isFetched = useSelector((state: any) => state.user.isFetched);
  const date = useSelector((state: any) => state.user.usersDate);
  const status = useSelector((state: any) => state.user.status);

  const getParams =  useCallback(() => {
    let params: any = {};
    params = {
      'filter[user_type]': activeType,
    };

    return params;
  }, [activeType]);

  useEffect(() => {
    let params = getParams();
    if(date?.start?.length > 0 && date?.end?.length > 0){
      if(tableData.order !== undefined) {
        params['sort'] = tableData.order === "ascend" ? tableData.field : ("-"+tableData.field);
      }
      if(!!searchValue) {
        params['filter[search]'] = searchValue;
      }

      params['filter[created_from]'] = date.start;
      params['filter[created_till]'] = date.end;
      if(params['filter[user_type]'] === 'all'){
        delete params['filter[user_type]']
      }
      dispatch(getUsers(params));
    }
    if(tableData.order !== undefined) {
      params['sort'] = tableData.order === "ascend" ? tableData.field : ("-"+tableData.field);
    }
    if(!!searchValue) {
      params['filter[search]'] = searchValue;
    }

    if(params['filter[user_type]'] === 'all'){
      delete params['filter[user_type]']
    }
    dispatch(getUsers(params));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date?.start, date?.end, dispatch, getParams, tableData]);

  useEffect(() => {
    let newData: any = [];
    usersData && usersData?.forEach((obj: any) => {
      newData.push({
        id: obj?.id,
        nickname: obj?.nickname,
        type: activeType,
        user_type: obj?.user_type,
        email: obj?.email,
        'total-spent': `${parseFloat(obj?.total_spent).toFixed(2)} ₪`,
        'total-received': `${parseFloat(obj?.total_received).toFixed(2)} ₪`,
        'active_subs': obj?.active_subs,
        'first-transaction': obj?.first_transaction !== null ? moment(obj?.first_transaction).format('L') : '-',
        'last-transaction': obj?.last_transaction !== null ? moment(obj?.last_transaction).format('L') : '-',
        firstPayment: obj?.first_transaction !== null ? moment(obj?.first_transaction).format('L') : '-',
        lastPayment: obj?.last_transaction !== null ? moment(obj?.last_transaction).format('L') : '-',
        firstEarning: obj?.first_transaction !== null ? moment(obj?.first_transaction).format('L') : '-',
        lastEarning: obj?.last_transaction !== null ? moment(obj?.last_transaction).format('L') : '-',
        created_at: obj?.created_at !== null ? moment(obj?.created_at).format('L') : '-',
        last_active: obj?.last_active !== null ? moment(obj?.last_active).format('L') : '-',
        avatar: obj?.avatar,
      });
    });
    setData(newData);
  }, [usersData, dispatch, getParams, activeType]);

  useEffect(() => {
    dispatch(setHeader(headerConfigs.users()));

    return () => {
      dispatch(resetHeader());
    };
  }, [dispatch]);

  const navigateToDetails = (id: number, type: string) => {
    setVisible(true);
    dispatch(getUsersDetails(id, type === 'user' ? 'client' : type));
  }

  const handleActiveType = useCallback((type: string) => {
    setActiveType(type);
    // setTableData([]);
    switch (type) {
      case "client":
        const clients = [
          "type",
          "total-received",
          "first-transaction",
          "last-transaction",
          "firstEarning",
          "lastEarning",
          "active_subs",
        ];
        setColumns(getCol().filter((i: any) => clients.indexOf(i.key) === -1));
        setDataSource(data.filter((i: any) => i.type === "client"));
        break;
      case "user":
        const users = ["nickname", "email", "created_at", "last_active", "option"];
        setColumns(getCol().filter((i: any) => users.indexOf(i.key) !== -1));
        setDataSource(data.filter((i: any) => i.type === "user"));
        break;
      case "artist":
        const artists = [
          "type",
          "total-spent",
          "firstPayment",
          "lastPayment",
          "first-transaction",
          "last-transaction",
        ];
        setColumns(getCol().filter((i: any) => artists.indexOf(i.key) === -1));
        setDataSource(data.filter((i: any) => i.type === "artist"));
        break;
      case "all":
        const all = [
          "firstPayment",
          "lastPayment",
          "firstEarning",
          "lastEarning",
          "active_subs",
        ];
        setColumns(getCol().filter((i: any) => all.indexOf(i.key) === -1));
        setDataSource(data);
    }
  }, [data]);


  useEffect(() => {
    handleActiveType(activeType);
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [activeType, handleActiveType]);

  const handleTableChange = (sortBy: string, order: string) => {
    let params = getParams();
    setIsLoading(true)
    if((sortBy && order !== undefined) || searchValue !== '') {
      params['sort'] = order === "ascend" ? sortBy : ("-"+sortBy);
      params['filter[search]'] = searchValue;
      params['filter[created_from]'] = date.start;
      params['filter[created_till]'] = date.end;
      if(params['filter[user_type]'] === 'all'){
        delete params['filter[user_type]']
      }
      dispatch(getUsers(params));
    }
  };

  const handleSearch = () => {
    setIsLoading(true)
    let params = getParams();
    if(!!searchValue) {
      params['filter[search]'] = searchValue;
      if(tableData.order !== undefined) {
        params['sort'] = tableData.order === "ascend" ? tableData.field : ("-"+tableData.field);
      }
    }
    if(date?.start?.length > 0 && date?.end?.length > 0){ 
      params['filter[created_from]'] = date.start;
      params['filter[created_till]'] = date.end;
    }
    if(params['filter[user_type]'] === 'all'){
      delete params['filter[user_type]']
    }
    dispatch(getUsers(params)); 
  }

  const loadMoreData = useCallback(() => {

    if(page !== lastPage){
      setIsLoading(true)
    }

    let params = getParams();
    if(page === lastPage) return;
    if((date?.start?.length > 0 && date?.end?.length > 0) || (tableData.order && tableData.field)) {
      params['page'] = page + 1;
      if(tableData.order !== undefined) {
        params['sort'] = tableData.order === "ascend" ? tableData.field : ("-"+tableData.field);
      }
      params['filter[created_from]'] = date.start;
      params['filter[created_till]'] = date.end;
      dispatch(getUsers(params));
    }
    if(params['filter[user_type]'] === 'all'){
      delete params['filter[user_type]']
    }
    if(!(date?.start?.length > 0 && date?.end?.length > 0) && !(tableData.order && tableData.field)) {
      params['page'] = page + 1;
      dispatch(getUsers(params));
    }

  }, [dispatch, page, getParams, tableData.field, tableData.order, date?.start, date?.end, lastPage]);

  const handleDrawerOpen = () => {
    setVisible(true);
  }

  const handleDrawerClose = () => {
    setVisible(false);
  }

  return (
    <div className="users">
      <Space className="users_header">
        <Space className="users_types" size={0}>
          <Button
            className={`users_types-button ${
              activeType === "client" ? "users_types-button--active" : ""
            }`}
            onClick={() => {
              setTableData([]);
              setIsLoading(true)
              handleActiveType("client");
            }}
          >
            <ClientsIcon /> Clients
          </Button>
          <Button
            className={`users_types-button ${
              activeType === "user" ? "users_types-button--active" : ""
            }`}
            onClick={() => {
              setTableData([]);
              setIsLoading(true)
              handleActiveType("user");
            }}
          >
            <UserIcon /> Users
          </Button>
          <Button
            className={`users_types-button ${
              activeType === "artist" ? "users_types-button--active" : ""
            }`}
            onClick={() => {
              setTableData([]);
              setIsLoading(true)
              handleActiveType("artist");
            }}
          >
            <VideoIcon /> Artists
          </Button>
          <Button
            className={`users_types-button ${
              activeType === "all" ? "users_types-button--active" : ""
            }`}
            onClick={() => {
              setTableData([]);
              setIsLoading(true)
              handleActiveType("all");
            }}
          >
            All
          </Button>
        </Space>
        <Space>
          <Input
            className="users_search-input"
            prefix={<SearchIcon style={{ marginRight: "13px" }} />}
            placeholder="Search"
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <Button onClick={handleSearch} className="users_search-btn">Search</Button>
        </Space>
      </Space>
        <SmartTable
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          className="users_table"
          loading={isLoading}
          key={activeType}
          onRow={(r: any) => ({
            onClick: () => navigateToDetails(r.id, r.user_type)
          })}
          onFetch={loadMoreData}
          onChange={(e: any, a: any, sort: any, d: any) => {
            setTableData(sort);
            handleTableChange((sort as any).field, (sort as any).order);
          }}
        />
      <UserDrawer
        usersDetailsData={usersDetailsData}
        handleDrawerClose={handleDrawerClose}
        handleDrawerOpen={handleDrawerOpen}
        visible={visible}
        status={status}
      />
    </div>
  );
};

export default User;
